import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["root", "panel", "frame"]

  connect() {
    this._escHandler = this._onEscape.bind(this)
    this._tradeCompletedHandler = this.close.bind(this)
    window.addEventListener("mulatrade:trade-completed", this._tradeCompletedHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this._escHandler)
    window.removeEventListener("mulatrade:trade-completed", this._tradeCompletedHandler)
  }

  open(event) {
    event?.stopPropagation?.()
    const url = event?.params?.url || event?.detail?.url
    if (!url || !this.hasRootTarget) return

    this.frameTarget.setAttribute("src", url)

    this.rootTarget.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.rootTarget.classList.remove("opacity-0")
      if (this.hasPanelTarget) {
        this.panelTarget.classList.remove("opacity-0", "scale-95")
      }
    })

    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this._escHandler)
  }

  close() {
    if (!this.hasRootTarget) return

    this.rootTarget.classList.add("opacity-0")
    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("opacity-0", "scale-95")
    }

    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this._escHandler)

    setTimeout(() => {
      this.rootTarget.classList.add("hidden")
      this.frameTarget.setAttribute("src", "")
      this.frameTarget.innerHTML = ""
    }, 200)
  }

  closeBackdrop(event) {
    if (event.target === this.rootTarget) this.close()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  _onEscape(event) {
    if (event.key === "Escape") this.close()
  }
}
